module.exports = __webpack_public_path__ + "static/media/language.e81f10da.png";